import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Badge, BadgeProps } from '@printdeal/ui-library';
import { messages } from '../../translations/proposals';
import { IterationStatus } from '../../../../services/customer/CustomerProposalService';

interface Props {
  status: IterationStatus
}

type StatusMap = Record<IterationStatus, { variant: BadgeProps['variant'], messageId: string }>;

const statusMap: StatusMap = {
  AwaitingConfirmation: { variant: 'primary', messageId: messages.AwaitingConfirmation.id },
  Approved: { variant: 'info', messageId: messages.Approved.id },
  Closed: { variant: 'error', messageId: messages.Closed.id },
  Rejected: { variant: 'dim', messageId: messages.Rejected.id },
};

const ProposalStatusBadge = ({ status }: Props) => {
  const statusInfo = statusMap[status];

  if (!statusInfo) {
    return null;
  }

  return (
    <Badge variant={statusInfo.variant}>
      <FormattedMessage id={statusInfo.messageId} />
    </Badge>
  );
};

export default ProposalStatusBadge;
